import z from "zod/v4";

export const teamMetadataTeamSchema = z.object({
  teamId: z.string(),
  market: z.string(),
  name: z.string(),
  fullName: z.string(),
  alias: z.string(),
  backgroundHex: z.string(),
  altHex: z.array(z.string()),
  logo: z.string().optional().nullable(),
});
export type TeamMetadataTeam = z.infer<typeof teamMetadataTeamSchema>;